import { LinguaRichText } from "@fi-solutions/lingua-runtime-vue";
import { defineComponent, h } from "vue";
import { locale } from "@/language/translation";
import {
  staticMessage,
  staticOccurrence,
  staticTranslationRevision,
  translateStaticMessage,
} from "@/language/staticTranslations";

export default defineComponent({
  name: "StaticTranslation",
  props: {
    keyName: { type: String, required: true },
    ns: { type: String, default: "app" },
  },
  setup(props, { slots }) {
    return () => {
      void staticTranslationRevision.value;
      // Route a missing rich message through the ordinary adapter as well, so Lingua reports the
      // missing key and keeps the same visible development/production fallback as plain t() calls.
      const message =
        staticMessage(props.ns, props.keyName) ??
        translateStaticMessage(props.ns, props.keyName);
      const markersActive =
        document.documentElement.dataset.linguaExtensionActive === "true";
      return h(
        LinguaRichText,
        {
          message,
          locale: locale.value,
          occurrence: markersActive ? staticOccurrence(props.ns, props.keyName) : undefined,
        },
        slots,
      );
    };
  },
});
